module.exports = __webpack_public_path__ + "img/public/SiteIcons/twitterShareIcon.svg?0b6e2b6f";